var render = function render(){var _vm=this,_c=_vm._self._c;return _c('group-form',{ref:"form",attrs:{"columnMode":true,"group":_vm.draft,"formAction":_vm.action},on:{"submitSuccess":_vm.onSubmitSuccess,"removeImage":_vm.onRemoveImage,"currencySelected":function($event){return _vm.enableNextStep()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }